import { store } from "../../store";

export const REMOTE_URL = "";
export const GET_JOB_URL = "/api/v1/job_titles";
export const ADD_JOB_URL = "/api/v1/job_titles/create";
export const UPD_JOB_URL = "/api/v1/job_titles/update";
